<template>
  <div id="app" class="xxx">
    <button
      v-if="!isInstalled && showInstallBtnList.includes($route.path)"
      type="button"
      class="btn btn-warning btn-lg btn-block"
      id="installBtn"
    >
      Installer l'application Mobi AN
    </button>
    <button
     @click="maj()"
      type="button"
      class="btn btn-success btn-lg btn-block"
      id="majBtn"
      v-if="isUpgrading && getUpgrade!=='upgrading'"
    > 
      Mettre à jour l'application Mobi AN
      
    </button>
    <div class="alert alert-warning" v-if="getUpgrade==='cannot'">
     Des pointages non importés existent toujours {{ getLocalPointagesFalse }} (pointage) / {{getLocalSupplementsFalse}} (suplément). Pour terminer la mise à jour, veuillez rester connecté à internet  
    </div>
    <loadingPanel></loadingPanel>
    <router-view />
  </div>
</template>

<script>
import LoadingPanel from "@/components/loading-panel.vue";
import update from "./update.js";
import { mapGetters } from "vuex";
import store from "@/store";
import $inoe from "@/config";
export default {
  components: {
    LoadingPanel,
  },
  mixins: [update],

  beforeRouteEnter(to, from, next) {  
    next("/session/register");
  },
  data() {
    return {
      isInstalled: false,
      showInstallBtnList: ["/", "/session/register", "/moncompte"],
    };
  },
  
  computed: {
    ...mapGetters("session", ["storeWillUpdate", "getMemDBStatus"]),
     ...mapGetters("parametres", [
      "getLastSynchro",
      "getMobiVersion",
      "getLocalPointagesFalse",     
      "getLocalSupplementsFalse","getUpgrade"
    ]),
    isUpgrading:function(){
      return $inoe.isUpgrading() ;
    }
  },methods:{
notifyWithServiceWorker(title, options) {
  const swreg = this.$swreg;
  if (swreg && typeof swreg.showNotification === "function") {
    return swreg.showNotification(title, options);
  }
  console.warn("[ANMOBI][APP] SW registration indisponible, notification ignorée", {
    title,
  });
  return Promise.resolve();
},
maj() {
  console.log("maj")
      store
        .dispatch("parametres/fetchPointagesLocal")
    },
  },
  watch: {
    storeWillUpdate(newVal, oldVal) {
      if (!oldVal && newVal) {
        this.notifyWithServiceWorker("Synchronisation Mobi...", {
          body: "Téléchargement des données Mobi en cours",
          tag: "InoeMobi",
          icon: "./img/icons/android-icon-96x96.png"
        });
      }
      if (oldVal && !newVal) {
         this.notifyWithServiceWorker("Synchronisation Mobi terminée", {
          body: "Téléchargement Terminé, Chargement des données en mémoire",
          tag: "InoeMobi",
          icon: "./img/icons/android-icon-96x96.png"
        });
      }
    },
  },
};
</script>

<style lang="scss">
#installBtn {
  position: fixed;
  z-index: 99;
}
body {
  overscroll-behavior-y: contain;
  overscroll-behavior-x: contain;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
}
</style>
